<template>
  <form-item
    v-model="innerValue"
    type="number"
    v-bind="$attrs"
    @keypress="keypress"
  >
    <template
      v-if="$slots.label"
      slot="label"
    >
      <slot name="label" />
    </template>
    <template
      v-if="$slots.header"
      slot="header"
    >
      <slot name="header" />
    </template>
    <template
      v-if="$slots.body"
      slot="body"
    >
      <slot name="body" />
    </template>
    <template
      v-if="errors.length>0"
      slot="error"
    >
      <template v-for="(error, i) in errors">
        <span
          v-if="error.isShow"
          :key="i"
          style="margin: 0"
          class="form-error is-visible"
          :data-test="`error-`+i"
        >{{ error.message }}</span>
      </template>
    </template>
  </form-item>
</template>

<script>
import FormItem from '@/components/atoms/FormItem'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    FormItem
  },
  mixins: [eventValidations],
  props: {
    value: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.$props.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    keypress (e) {
      this.onlyNumberInRange(e, this.$attrs.max, this.$attrs.min)
    }
  }
}
</script>
